import React from "react";
import styled from "styled-components";


const StyledHamburger = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  height: 48px;
  width: 48px;
  display: ${props => (props.theme.mobile ? "block" : "none")};

  .hamburger-top,
  .hamburger-bottom {
    position: absolute;
    top: 0;
    left: 0;
    width: 48px;
    height: 48px;

    transition: transform 0.25s cubic-bezier(0.4, 0.01, 0.165, 0.99),
      -webkit-transform 0.25s cubic-bezier(0.4, 0.01, 0.165, 0.99);
    transform: rotate(0);

    span {
      display: block;
      width: 17px;
      height: 1px;
      background: #000;
      position: absolute;
      left: 16px;
      z-index: 1;
    }
  }

  .hamburger-top span {
    top: 23px;
    transform: translateY(-3px);
  }

  .hamburger-bottom span {
    bottom: 23px;
    transform: translateY(3px);
  }

  &.is-open {
    .hamburger-top {
      transform: rotate(45deg);
      span {
        transform: translateY(0px);
        top: 23px;
      }
    }

    .hamburger-bottom {
      transform: rotate(-45deg);

      span {
        transform: translateY(0px);
        bottom: 23px;
      }
    }
  }
`;

const Hamburger = ({ handleToggleMenu, openMenu }) => (
  <StyledHamburger
    onClick={handleToggleMenu}
    className={`hamburger ${openMenu ? "is-open" : ""}`}
  >
    <span className="hamburger-top">
      <span />
    </span>
    <span className="hamburger-bottom">
      <span />
    </span>
  </StyledHamburger>
);

export default Hamburger;
